var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useEventBus } from "@vueuse/core";
import { historiesFetcher } from "@/api/histories";
import { updateTags } from "@/api/tags";
import Filtering, { contains, expandNameTag } from "@/utils/filtering";
import { rethrowSimple } from "@/utils/simple-error";
const { emit } = useEventBus("grid-router-push");
/**
 * Request and return data from server
 */
function getData(offset, limit, search, sort_by, sort_desc) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { data, headers } = yield historiesFetcher({
            view: "summary",
            keys: "username,create_time",
            limit,
            offset,
            search,
            sort_by: sort_by,
            sort_desc,
            show_own: false,
            show_published: false,
            show_shared: true,
            show_archived: true,
        });
        const totalMatches = parseInt((_a = headers.get("total_matches")) !== null && _a !== void 0 ? _a : "0");
        return [data, totalMatches];
    });
}
/**
 * Declare columns to be displayed
 */
const fields = [
    {
        key: "name",
        title: "Name",
        type: "operations",
        operations: [
            {
                title: "View",
                icon: faEye,
                condition: (data) => !data.deleted,
                handler: (data) => {
                    emit(`/histories/view?id=${data.id}`);
                },
            },
        ],
    },
    {
        key: "id",
        title: "Size",
        type: "datasets",
    },
    {
        key: "tags",
        title: "Tags",
        type: "tags",
        disabled: true,
        handler: (data) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield updateTags(data.id, "History", data.tags);
            }
            catch (e) {
                rethrowSimple(e);
            }
        }),
    },
    {
        key: "create_time",
        title: "Created",
        type: "date",
    },
    {
        key: "update_time",
        title: "Updated",
        type: "date",
    },
    {
        key: "username",
        title: "Username",
        type: "text",
    },
];
/**
 * Declare filter options
 */
const validFilters = {
    name: { placeholder: "name", type: String, handler: contains("name"), menuItem: true },
    user: { placeholder: "user", type: String, handler: contains("username"), menuItem: true },
    tag: {
        placeholder: "tag(s)",
        type: "MultiTags",
        handler: contains("tag", "tag", expandNameTag),
        menuItem: true,
    },
};
/**
 * Grid configuration
 */
const gridConfig = {
    id: "histories-shared-grid",
    fields: fields,
    filtering: new Filtering(validFilters, undefined, false, false),
    getData: getData,
    plural: "Histories",
    sortBy: "update_time",
    sortDesc: true,
    sortKeys: ["create_time", "name", "update_time", "username"],
    title: "Shared Histories",
};
export default gridConfig;
